import { Component, OnInit } from "@angular/core";
import { ContentHeader } from "../../../layout/components/content-header/content-header.component";
import { FormBuilder } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { UserService } from "../../../api/services/user.service";
import { BaseListDirective } from "../../../util/directives/base-list.directive";
import { ModalService } from "../../../util/service/modal.service";
import Swal from "sweetalert2";
import { colors } from "../../../colors.const";
import { EnumDropdownOption, EnumService } from "../../../util/service/enum.service";
import { EntityTyp } from "../../../util/enums/entity-typ.enum";
import { UserListItemDto } from "../../../api/models/user-list-item-dto";
import { EnumDisplayService } from "../../../util/service/enum-display.service";
import { OfficeNameDto } from "app/api/models";
import { AuthenticationService } from "app/api/services";
import { UserRole } from "../../../server/enums/user-role.enum";
import { AuthService } from "../../../util/service/auth.service";
import { ToastrService } from "ngx-toastr";
import { CaslAction } from "../../../server/enums/casl-action.enum";

@Component({
    selector: "app-user-list",
    templateUrl: "./user-list.component.html",
    styleUrls: ["./user-list.component.scss"],
    standalone: false
})
export class UserListComponent extends BaseListDirective<UserListItemDto> implements OnInit {
  override modalType = EntityTyp.User;
  protected readonly UserRole = UserRole;
  protected readonly CaslAction = CaslAction;
  protected readonly EntityTyp = EntityTyp;

  public contentHeader: ContentHeader;
  rollenOptions!: EnumDropdownOption[];
  offices: OfficeNameDto[] = [];

  constructor(
    protected override route: ActivatedRoute,
    protected override router: Router,
    private userService: UserService,
    protected override modalService: ModalService,
    public enumService: EnumService,
    protected override fb: FormBuilder,
    public enumDisplayService: EnumDisplayService,
    protected authenticationService: AuthenticationService,
    protected authService: AuthService,
    private toastrService: ToastrService
  ) {
    super(fb, route, router, modalService);
  }

  ngOnInit(): void {
    this.offices = this.route.snapshot.data["offices"];
    this.rollenOptions = this.enumService.userRoleDropdownOptions;
    this.contentHeader = {
      headerTitle: "Benutzer",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Startseite",
            isLink: true,
            link: "/",
            translate: "MENU.HOME",
          },
          {
            name: "Benutzer",
            isLink: false,
            translate: "MENU.USERS",
          },
        ],
      },
    };

    this.initFilter({
      firstName: [null],
      lastName: [null],
      email: [null],
      rolle: [null],
      appLogin: [null],
      officeId: [null],
    });
  }

  reload() {
    this.userService.userControllerFindAll(this.filter.value).subscribe({
      next: (page) => {
        this.page = page;
        this.syncPageNumber();
      },
    });
  }

  async openModal(id?: number) {
    await this.modalService.openEntityModal(EntityTyp.User, id);
    this.reload();
  }

  async delete(id) {
    const confirm = await Swal.fire({
      text: "Möchten Sie diesen Benutzer wirklich löschen?",
      icon: "error",
      showCancelButton: true,
      focusCancel: true,
      confirmButtonColor: colors.solid.danger,
      confirmButtonText: "Löschen",
      cancelButtonText: "Abbrechen",
    });
    if (confirm.isConfirmed) {
      this.userService.userControllerDelete({ id }).subscribe((res) => {
        this.reload();
      });
    }
  }

  async loginAs(user: UserListItemDto) {
    const confirm = await Swal.fire({
      title: "Einloggen",
      text: `Möchten Sie sich wirklich als ${user.email} einloggen?`,
      icon: "question",
      showCancelButton: true,
      focusCancel: true,
      confirmButtonColor: colors.solid.success,
      confirmButtonText: "Einloggen",
      cancelButtonText: "Abbrechen",
    });
    if (confirm.isConfirmed) {
      this.authService.loginAs(user.id);
    }
  }

  async restore(id) {
    const confirm = await Swal.fire({
      text: "Möchten Sie diesen Benutzer wirklich wiederherstellen?",
      icon: "question",
      showCancelButton: true,
      focusCancel: true,
      confirmButtonColor: colors.solid.info,
      confirmButtonText: "Wiederherstellen",
      cancelButtonText: "Abbrechen",
    });
    if (confirm.isConfirmed) {
      this.userService.userControllerRestore({ id }).subscribe((res) => {
        this.toastrService.success("Erfolgreich wiederhergestellt", "Erfolgreich wiederhergestellt");
        this.reload();
      });
    }
  }
}
